import { render, staticRenderFns } from "./ValidationList.vue?vue&type=template&id=3a4c75db&"
import script from "./ValidationList.vue?vue&type=script&lang=js&"
export * from "./ValidationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports